// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

   
    let email_signup = document.querySelector( "#email-signup" )
    if( email_signup ){
        let interested_in = document.querySelectorAll( "[name*=interested_in]" )
        console.log( interested_in )
        interested_in.forEach( check => {
            check.addEventListener( "change", (e) => {
                let i = e.target.value
                if( e.target.checked ){

                    let hidden = document.createElement( "input" )
                    hidden.type = "hidden"
                    hidden.name = "cc[]"
                    email_signup.appendChild( hidden )

                    let hidden1 = document.createElement( "input" )
                    hidden1.type = "hidden"
                    hidden1.name = "cc[]"
                    email_signup.appendChild( hidden1 )

                    switch( i ){
                        case "Golf":
                            hidden.value = "brentwebber@quaillodge.com"
                            hidden1.value = "marketing@quaillodge.com"
                            break;
                        case "Hotel":
                            hidden.value = "marketing@quaillodge.com"
                            break;
                        case "Events":
                            hidden.value = "sales@quaillodge.com"
                            break;
                    }
                }else{
                    switch( i ){
                        case "Golf":
                            email_signup.querySelector( "[value='brentwebber@quaillodge.com']" ).remove()
                            email_signup.querySelector( "[value='marketing@quaillodge.com']" ).remove()
                            break;
                        case "Hotel":
                            email_signup.querySelector( "[value='marketing@quaillodge.com']" ).remove()
                            break;
                        case "Events":
                            email_signup.querySelector( "[value='sales@quaillodge.com']" ).remove()
                            break;
                    }
                }
            } )
        } )

    }

    $(document).ready(function () {

        // Main Nav Dropdown
        $("#primary-nav li").hover(function(){
            $(this).addClass("hover");
            $('ul.submenu',this).fadeIn(200);
        }, function(){
            $(this).removeClass("hover");
            $('ul.submenu',this).fadeOut(200);
        });

        //Section video play / pause
        const buttonsArray = document.querySelectorAll('#controlsVideos a');
        const video = document.querySelector('#videoIntroHome');

        if (buttonsArray.length > 0) {
            buttonsArray.forEach(button => {
                button.addEventListener('click', actionFuction )
            });
        }
        function actionFuction(e){
            const playButton = e.target.nextElementSibling;
            const pauseButton = e.target.previousElementSibling;
            if(this.classList.contains('pause-video')){
                pauseButton.classList.remove('hidden')
                this.classList.add('hidden')
                video.pause();
            }
            else{
                playButton.classList.remove('hidden')
                this.classList.add('hidden')
                video.play();
            }
        }

    });

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });
    
    $('.reviews-sym').slick({
        accessibility: false,
        appendDots: $('.review-dots'),
    })

    $('.sym-simple-slider').slick({
         arrows:false,
         accessibility: true,
        autoplay: true,
        autoplaySpeed: 5000,
        dots:true,
        fade:true,
        appendDots: $('.slick-slider-dots')
    });

    //custom dots 
    $('.js-slick-dots').each((i, dots) => {
        $('button', dots).click((e) => {
            let slideTo = $(e.currentTarget).data('goto');
            $(dots).closest('.sym-simple-slider').slick('slickGoTo', slideTo);
        });
    });

    
     $('.slider-left').slick({
        accessibility: false,
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 5000,
        speed: 700,
        fade: true,
        appendDots: $('.slider-block__dots'),
        asNavFor:$('.slider-right'),
    });
    
    $('.slider-right').slick({
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 5000,
        speed: 700,
        fade: true,
        asNavFor:$('.slider-left')
    });
    //custom dots 
    $('.slider-block__dots').each((i, dots) => {
        $('button', dots).click((e) => {
            let slideTo = $(e.currentTarget).data('goto');
            $(dots).closest('.slider-left').slick('slickGoTo', slideTo);
        });
    });
    
    $('.sym-slides-img-venues').slick({
        accessibility: true,
        arrows:false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000
    });
  
    //Custom Slider carousel
    $('.gallery-slider-left').slick({
        accessibility: true,
        arrows:true,
        dots: true,
        rtl:true,
        fade: false,
        slidesToShow: 3,
        infinite: true,
        centerMode:false,
        variableWidth: true,
        asNavFor:$('.gallery-slider-right'),
        appendDots:$('.gallery-carousel__dots-carousel'),
        appendArrows:$('.gallery-carousel__arrows-carousel')
    });
    $('.gallery-slider-right').slick({
        accessibility: true,
        slidesToShow: 1,
        rtl:true,
        asNavFor:$('.gallery-slider-left')
    });



    //----------------------------
    let buttonNavSocial= document.getElementById('social-mobile');
    let buttoMenu= document.getElementById('btn-menu-js');
    let menu = document.querySelectorAll('.menu-block')[0];
    let menuCloseButton = document.querySelectorAll('.menu-block__close')[0];

    if (buttoMenu){
        buttoMenu.addEventListener('click', function (){
            menu.classList.add('active');
            buttonNavSocial.classList.remove('hidden');
        })
    }

    menuCloseButton.addEventListener('click', function (){
        menu.classList.remove('active');
        buttonNavSocial.classList.add('hidden');
    })


    //Menu Responsive
    let menuBtn = document.getElementById('menuButton');
    let closeMenuButton = document.getElementById('closeMenuButton');
    if(menuBtn){
        menuBtn.addEventListener("click", function(){ 
            menuBtn.classList.add('openMenu');
            document.getElementsByClassName('mobile-navigation')[0].classList.add('openMenu');
            document.getElementById('header').classList.add('openMenu');
        });
    }
    if(closeMenuButton){
        closeMenuButton.addEventListener("click", function(){ 
            menuBtn.classList.remove('openMenu');
            document.getElementsByClassName('mobile-navigation')[0].classList.remove('openMenu');
            document.getElementById('header').classList.remove('openMenu');
        });
    }

    //email signup animation 
    if(document.getElementById('email-signup')){
        document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
            this.parentElement.classList.add('moved');
        })
        document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
            this.parentElement.classList.add('moved');
        }) 
        document.getElementById('email-signup_email_address').addEventListener('focus', function(){
        this.parentElement.classList.add('moved');
        })

	}
    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}
    //custom Menu
    document.querySelectorAll('.js-menu-tab').forEach((btn) => {
        btn.addEventListener('click', _ => {
            $('.js-menu-tab.active').removeClass('active');
            $(btn).addClass('active');
            $('.quad-menus__menu-content.active').removeClass('active');
            var tabNumber = $(btn).attr('data-menuid');
            var tabToOpen = ".quad-menus__menu-content[data-menuid='" + tabNumber + "']";
            $(tabToOpen).addClass('active');
            $('.quad-menus__tabs-image.active').removeClass('active');
            var imgToOpen = ".quad-menus__tabs-image[data-menuid='" + tabNumber + "']";
            $(imgToOpen).addClass('active');
            $('.name-bg.active').removeClass('active');
            var wordToOpen = ".name-bg[data-menuid='" + tabNumber + "']";
            $(wordToOpen).addClass('active');
        });
    });

    //Custom gallery
    const customLightboxFooter = new LBX(".js-my-lightbox", {
        fullScreen:true,
        icons: {
			next: '<svg width="25" height="19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m15.62 18.75-2.19-2.27 5.55-5.55H0V7.81h18.98l-5.55-5.55 2.19-2.27L25 9.37l-9.38 9.38Z" fill="#fff"/></svg>',
			prev: '<svg width="25" height="19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m9.38 18.75 2.19-2.27-5.55-5.55H25V7.81H6.02l5.55-5.55L9.38-.01 0 9.37l9.38 9.38Z" fill="#fff"/></svg>'
		}
    });

    document.querySelectorAll('.social-media li a svg').forEach(item => {
        if(item.getAttribute("id")){
            item.removeAttribute("id");
        }
    });

    /* Anchor Animation */
    let aHref = document.querySelectorAll("a[href^='#']:not(:where(a[data-fancybox], a[data-lbx], a[data-filter], a.accordion-toggle, a#js_btn_book, a.ui-state-default))");
    if(aHref){
        aHref.forEach(function(a_href) {
            a_href.addEventListener('click', function(e){
                e.preventDefault();
                let strAnchor = this.hash.slice(1);
                animateto(strAnchor);
            });
        });
    }

    let Body = document.body;
    customLightboxFooter.beforeShow = function () {
        Body.classList.add('scroll-no');
    };
    customLightboxFooter.beforeClose = function () {
        Body.classList.remove('scroll-no');
    };

    let aBtn = document.querySelectorAll(".btn:not(.attractions-map__expand), .signup-btn");
	if(aBtn){
		setTimeout(() => {
			aBtn.forEach(function(a_btn) {
				let htmlString = a_btn.innerText;
				a_btn.innerHTML = '<span>'+htmlString+'</span>';
			});
		}, 500);
	}

    let screenHeight = document.documentElement.clientHeight;
	let homeTopImg = document.getElementById('home');
	if(homeTopImg){
		homeTopImg.querySelectorAll('.top-content-homepage figure, .top-content-homepage video').forEach(entry => {
			if(screen.width < 600){
				entry.style.height = (screenHeight - 120)+'px';
			} else {
				entry.style.height = (screenHeight - 120)+'px';
			}
		});
		window.addEventListener("resize", function(){
			screenHeight = document.documentElement.clientHeight;
			homeTopImg.querySelectorAll('.top-content-homepage figure, .top-content-homepage video').forEach(entry => {
				if(screen.width < 600){
					entry.style.height = (screenHeight - 120)+'px';
				} else {
					entry.style.height = (screenHeight - 120)+'px';
				}
			});
		});
	}

    })();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 80;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    /* Time Interval */
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

}
/* Ease Movement */
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
    const menu = document.querySelector('#menu-block');
    const isMenuVisible = menu && menu.classList.contains('active');
    const elements = document.querySelectorAll('.privary-navigation__item a, .social-media a');
    
    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('#menu-block');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }


    let btnsPopUp = document.querySelectorAll('.pop-up-select__bottom a');
    let btnPopUpClose = document.querySelector('.pop-up-golf-or-hotel__btn-close');
    const popUpContainer = document.querySelector('.pop-up-golf-or-hotel');
    const popUpSelect = document.querySelector('.pop-up-select');
    const popUpForm = document.querySelector('.pop-up-form');
    const body = document.querySelector('body');
    let maxPopUpDisplays = 0;
    let notDisplayedExitIntent = true;
    let notDisplayedLoadPage = true;

    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
    }

    function getCookie(name) {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            const [key, value] = cookie.trim().split('=');
            if (key === name) return value;
        }
        return null;
    }

    function incrementCookie(name, maxCount) {
        let count = parseInt(getCookie(name)) || 0;
        if (count < maxCount) {
            setCookie(name, count + 1, 1);
            return true;
        }
        return false;
    }

    function closePopUp() {
        popUpContainer.close();
    }

    if (btnsPopUp && popUpContainer) {
        maxPopUpDisplays = popUpContainer.getAttribute('max-display');
        if (incrementCookie('popUpDisplayCount', maxPopUpDisplays)) {
            btnsPopUp.forEach((singleBtn) => {
                singleBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    popUpSelect.classList.remove('active');
                    popUpForm.classList.add('active');
                    if (singleBtn.getAttribute('id') === 'btn-pop-golf') {
                        document.querySelector('.pop-up-form__bottom-golf').classList.add('active');
                    } else {
                        document.querySelector('.pop-up-form__bottom-hotel').classList.add('active');
                    }
                });
            });

            btnPopUpClose.addEventListener('click', (e) => {
                e.preventDefault();
                closePopUp();
            });

            body.addEventListener('mouseleave', (e) => {
                if (notDisplayedExitIntent === true) {
                    setTimeout(() => {
                        popUpContainer.showModal();
                        notDisplayedExitIntent = false;
                    }, 3000);
                }
            });

            if(notDisplayedLoadPage === true){
                setTimeout(() => {
                    popUpContainer.showModal();
                    notDisplayedLoadPage = false;
                }, 10000);
            }

            function completedForm(){
                setCookie('popUpDisplayCount', 5, 15);
                console.log('The form is completely filled out');
            }
        } else {
            console.log('The pop-up was already displayed the maximum number of times allowed today.');
        }
    }

});